import { RemoteSalesPointsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const salesPointsService = new RemoteSalesPointsService(httpClient)
